import { Box, CircularProgress, CircularProgressProps, Typography } from "@mui/material";
import { FC } from "react";

interface IProps extends CircularProgressProps {
    maxValue: number
}

const CircularProgressWithLabel: FC<IProps> = ({ maxValue, value, ...props }) => {
    return (
        <Box sx={{ position: 'relative', display: 'inline-flex' }}>
            <CircularProgress  variant="determinate" value={(value ?? 0) * 100 / maxValue} {...props} />
            <Box
                sx={{
                    top: 0,
                    left: 0,
                    bottom: 0,
                    right: 0,
                    position: 'absolute',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    
                }}
            >
                <Typography
                    variant="h6"
                    component="div"
                    color="text.secondary"
                >{value}</Typography>
            </Box>
        </Box>
    );
}
export default CircularProgressWithLabel;